import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FallaufgabeLernbegleiter, FallAufgabenStatus } from '@reflact/ipkv-types';
import { Api } from './api';

export const fallaufgabeResolver: ResolveFn<void> = async (route, state) => {
  const api = inject(Api);
  return await api.loadFallaufgabe();

}